import * as types from './types';

import { execApi, execApiWithParam } from '../api/apiActions';
import LinksApi from '../../apis/links';

export const getLinks = () => {
    return dispatch => {
        dispatch(execApi({
                type: types.GET_LINKS,
                api: LinksApi.getLinks,
                successCallback: response => {
                    dispatch({
                        type: types.GET_LINKS,
                        payload: response.links,
                    })
                },
                useErrorDialog: true,
            })
        );
    };
};

export const getUrlForAssociatedLink = (callee) => {
    return dispatch => {
        dispatch(execApiWithParam({
            type: types.GET_URL_FOR_ASSOCIATED_LINK,
            api: LinksApi.getUrlForAssociatedLink,
            param: callee,
            successCallback: response => {
                dispatch({
                    type: types.GET_URL_FOR_ASSOCIATED_LINK,
                    payload: response.url,
                });
                window.open(response.url, '_blank')
            },
            useErrorDialog: true,
        }));
    }
}



// WEBPACK FOOTER //
// ./src/actions/links/linkActions.js